import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import { GoogleLogin } from '@react-oauth/google';
import { useLoginUserByGoogle } from './api/postLogonLoginGoogle';
import { useState } from 'react';
import ToastMessage
 from 'components/toastMessage';
export const AuthGoogleLogin = ({ url, onSuccess}) => {

  const [toastData, setToastData] = useState(null);
  const { mutate: login, isLoading: isLoggingIn } = useLoginUserByGoogle({url, onSuccess: () => {
    onSuccess();
  }});
  return (
    <Stack>
        <GoogleLogin
            onSuccess = {credentialResponse => {
              console.log(credentialResponse);
              var token = credentialResponse.credential;
              login({token});
             
            }}          
            onError={() => {
              setToastData({ severity: 'error', message: 'Błąd podczas logowania Google' });
            }}          
          />
          {toastData && (
        <ToastMessage
          open
          onClose={() => setToastData(null)}
          severity={toastData.severity}
          message={toastData.message}
        />
      )}
    </Stack>
  );
};

GoogleLogin.propTypes = {
  onSuccess: PropTypes.func,
};
